import { observer } from 'mobx-react-lite'

import { SelectField } from 'shared/ui/Select/SelectField/SelectField.tsx'
import { TextField } from 'shared/ui/TextField'
import { IconButton, Label } from 'shared/ui'
import {
  type IBrunch,
  type IVRStore,
} from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/IVR/store/IVRStore.ts'
import styles from './styles.module.scss'

export const Brunch = observer(
  ({ brunch, store, withLabel }: { brunch: IBrunch; store: IVRStore; withLabel: boolean }) => {
    const { key, title } = brunch
    const { getBrunchKeyOptions, updateBrunch, deleteBrunch } = store
    return (
      <div className={styles.wrap}>
        <SelectField
          items={getBrunchKeyOptions(brunch)}
          setValue={(value) => updateBrunch({ ...brunch, key: value })}
          value={key}
          labelText={withLabel ? 'Key' : undefined}
          btnProps={{
            fullWidth: true,
            typeBtn: 'stroke',
            size: 'large',
            justifyContent: 'space-between',
          }}
          dropdownProps={{
            width: 90,
            propsDropdownList: {
              minItemWidth: 0,
            },
          }}
        />
        <div>
          {withLabel && (
            <Label
              label={{
                text: 'Name',
              }}
              marginBottom={4}
            />
          )}
          <TextField
            variant={'stroke'}
            size={'medium'}
            InputProps={{
              placeholder: 'Option',
            }}
            value={title}
            onChange={(value) => updateBrunch({ ...brunch, title: value })}
          />
        </div>
        <IconButton
          onClick={() => deleteBrunch(brunch)}
          ariaLabel={'Delete'}
          size={'medium'}
          color={'secondary'}
          variant={'icon'}
          icon={'delete'}
          tooltipProps={{
            label: 'Delete',
            placement: 'top',
          }}
          className={styles.delete}
        />
      </div>
    )
  }
)
